export default {
  PROCESS: '简单处理',
  EFFECT: '效果',
  ADJUST: '图像调节',

  PROCESS_ORIGIN: '原图',
  PROCESS_GRAYSCALE: '灰度',
  PROCESS_SOBEL: '边缘检测',
  PROCESS_INVERT: '反色',
  PROCESS_SEPIA: '褐色化',
  
  ADJUST_LIGHTNESS: '亮度',
  ADJUST_HUE: '色相',
  ADJUST_SATURATION: '饱和度',
  ADJUST_ALPHA: '透明度',
  ADJUST_GAMMA: '伽马',
  ADJUST_POSTERIZE: '色阶',

  EFFECT_ORIGIN: '原图',
  EFFECT_OLD: '怀旧',
  EFFECT_LINEDRAWING: '素描',
  EFFECT_OILDRAWING: '油画',
  EFFECT_NATURAL: '自然',
}